module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.cls
  }, [(_vm.iosShow) ? _c('a', {
    attrs: {
      "href": _vm.iosLink
    },
    on: {
      "click": _vm.recordIosTrack
    }
  }, [_vm._v(_vm._s(_vm.text))]) : _c('span', {
    on: {
      "click": _vm.toDownloadPage
    }
  }, [_vm._v(_vm._s(_vm.text))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c3a61f3"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./static/components/open-app/index.vue
// module id = 245
// module chunks = 1 2 3 4 5 7 8 10 13 19 45